import { arrayOf, bool, number, oneOf, shape, string } from 'prop-types'

import { PLAN_TYPE } from './constants'

export const planShape = shape({
  planType: oneOf([PLAN_TYPE.YEARLY, PLAN_TYPE.MONTHLY]).isRequired,
  priceCents: number.isRequired,
  currency: string.isRequired,
})

export const plansShape = arrayOf(planShape)

export const subscriptionShape = shape({
  id: number,
  billingCycle: oneOf([PLAN_TYPE.MONTHLY, PLAN_TYPE.YEARLY]),
  status: string,
  statusLabel: string,
  price: string,
  renewsOn: string,
  periodEndDate: string,
  paymentMethod: string,
  downloadsUsed: number,
  downloadLimit: number,
  canceledAt: string,
  canceledByAdmin: bool,
  endedOn: string,
  updatePaymentUrl: string,
  planType: oneOf([PLAN_TYPE.MONTHLY, PLAN_TYPE.YEARLY]),
  tier: string,
  gracePeriodEligible: bool,
  scheduledPlanSwitchTo: string,
  scheduledPlanSwitchAt: string,
  pausedAt: string,
  pausedUntil: string,
  userPauseScheduledAt: string,
  userPause: bool,
})

export const paymentHistoryShape = arrayOf(
  shape({
    id: number,
    amountPaid: string,
    taxAmount: string,
    currency: string,
    paymentDate: string,
    status: string,
    statusLabel: string,
    invoiceUrl: string,
    paymentMethod: string,
    billingPeriod: string,
  })
)

export const subscriptionPromoSectionShape = shape({
  images: shape({
    wave: string.isRequired,
    waveLarge: string.isRequired,
    butterfly: string.isRequired,
    bird: string.isRequired,
    flower: string.isRequired,
  }).isRequired,
  locale: string,
  ctaUrl: string,
  subscriptionCatalogValue: string,
  subscriptionFlowEnabled: bool,
  isActiveSubscriber: bool,
  showPremiumPlans: bool,
})
